// extracted by mini-css-extract-plugin
export default {"container":"style_container__yDQQA","boxesContainer":"style_boxesContainer__g2A54","fadeInDown":"style_fadeInDown__tnD69","title":"style_title__-vyvK","p":"style_p__OaWt+"};